import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { class: "action-list" }

import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { getCurrentInstance, reactive, onActivated, ref } from 'vue'
import Pagination from '@/components/Pagination.vue'
import { getProjectBrandListApi, getFiltersListApi } from '../../apis/brand-expand'
import { ProjectStatus, CooperateType, ProjectOrigin } from '@/enums/brand'
import Keys from '@/constant/key'
import { joinParams } from '@/utils'


export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectBrand',
  setup(__props) {

const { proxy } = getCurrentInstance() as any
const router = useRouter()
const route = useRoute()
const store = useStore()

const filters = reactive({
    applyfor_name: route.query.name || '',
    brand_name: '',
    raise_name: '', // 需求提出人
    creation_status: '', // 合作方式
    check_status: '', // 处理状态
    start_date: '',
    end_date: '',
    page: 1,  // 当前页码
    page_size: 10, // 每页显示条数
})
const filterProjectList = ref<any[]>([]) // 项目名称筛选项列表
const filterBrandList = ref<any[]>([]) // 品牌筛选项列表
const getFiltersList = async () => {
    const { code, data, msg } = await getFiltersListApi() as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }

    filterProjectList.value = data.applyfor_names
    filterBrandList.value = data.brand_name
}
getFiltersList()


const tableData = ref([])
const total = ref(0)
const getList = async () => {
    const { start_date, end_date } = filters
    if (start_date && !end_date || !start_date && end_date) {
        return proxy.$message({ type: 'error', message: '请同时选择创建开始时间和创建结束时间' })
    }
    
    const { code, data, msg } = await getProjectBrandListApi(filters) as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }

    tableData.value = data.data
    total.value = data.total
}
getList()

// 跳转至编辑页
const toEdit = (row, t) => {
    const { id, applyfor_id } = row
    router.push(`/brand-expand/project-brand-detail?brand_id=${id}&project_id=${applyfor_id}&t=${t}`)
}

const onExport = () => {
    window.open(`${Keys.baseUrl}/brand/receiveWorkBrand?${joinParams({...filters, user_id: store.state.user.userInfo.id})}&is_export=1`)
}
const onSearch = () => {
    filters.page = 1
    getList()
}
const onPageChange = (val) => {
    filters.page = val
    getList()
}
const onSizeChange = (val) => {
    filters.page_size = val
    getList()
}
onActivated(() => {
    filters.applyfor_name = route.query.name || ''
    getList()
})

return (_ctx: any,_cache: any) => {
  const _component_el_select_v2 = _resolveComponent("el-select-v2")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_select_v2, {
        class: "filter-item",
        modelValue: filters.applyfor_name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.applyfor_name) = $event)),
        options: filterProjectList.value,
        props: {
                    value: 'applyfor_name',
                    label: 'applyfor_name',
                },
        placeholder: "请选择项目名称",
        clearable: "",
        filterable: ""
      }, null, 8, ["modelValue", "options"]),
      _createVNode(_component_el_select, {
        class: "filter-item",
        modelValue: filters.creation_status,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.creation_status) = $event)),
        placeholder: "请选择合作方式",
        clearable: "",
        filterable: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "普通合作",
            value: _unref(CooperateType)['普通合作']
          }, null, 8, ["value"]),
          _createVNode(_component_el_option, {
            label: "预付款合作",
            value: _unref(CooperateType)['预付款合作']
          }, null, 8, ["value"]),
          _createVNode(_component_el_option, {
            label: "渠道对接合作",
            value: _unref(CooperateType)['渠道对接合作']
          }, null, 8, ["value"]),
          _createVNode(_component_el_option, {
            label: "官网下单",
            value: _unref(CooperateType)['官网下单']
          }, null, 8, ["value"]),
          _createVNode(_component_el_option, {
            label: "不合作",
            value: _unref(CooperateType)['不合作']
          }, null, 8, ["value"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_select_v2, {
        class: "filter-item",
        modelValue: filters.brand_name,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.brand_name) = $event)),
        options: filterBrandList.value,
        props: {
                    value: 'brand_name',
                    label: 'brand_name',
                },
        placeholder: "请选择品牌名称",
        clearable: "",
        filterable: ""
      }, null, 8, ["modelValue", "options"]),
      _createVNode(_component_el_select, {
        class: "filter-item",
        modelValue: filters.check_status,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.check_status) = $event)),
        placeholder: "请选择状态",
        clearable: "",
        filterable: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "待处理",
            value: _unref(ProjectStatus)['待处理']
          }, null, 8, ["value"]),
          _createVNode(_component_el_option, {
            label: "处理中",
            value: _unref(ProjectStatus)['处理中']
          }, null, 8, ["value"]),
          _createVNode(_component_el_option, {
            label: "审批中",
            value: _unref(ProjectStatus)['审批中']
          }, null, 8, ["value"]),
          _createVNode(_component_el_option, {
            label: "已驳回",
            value: _unref(ProjectStatus)['已驳回']
          }, null, 8, ["value"]),
          _createVNode(_component_el_option, {
            label: "已完成",
            value: _unref(ProjectStatus)['已完成']
          }, null, 8, ["value"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.start_date,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filters.start_date) = $event)),
        placeholder: "创建开始时间",
        "value-format": "YYYY-MM-DD"
      }, null, 8, ["modelValue"]),
      _cache[8] || (_cache[8] = _createElementVNode("span", { class: "filter-item filter-divider" }, "-", -1)),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.end_date,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filters.end_date) = $event)),
        placeholder: "创建结束时间",
        "value-format": "YYYY-MM-DD"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: onSearch
      }, {
        default: _withCtx(() => _cache[6] || (_cache[6] = [
          _createTextVNode("搜索")
        ])),
        _: 1
      }),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: onExport
      }, {
        default: _withCtx(() => _cache[7] || (_cache[7] = [
          _createTextVNode("导出")
        ])),
        _: 1
      })
    ]),
    _createVNode(_component_el_table, {
      data: tableData.value,
      border: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "applyfor_name",
          label: "项目名称"
        }),
        _createVNode(_component_el_table_column, {
          prop: "brand_name",
          label: "品牌"
        }),
        _createVNode(_component_el_table_column, {
          prop: "is_replace_name",
          label: "是否可替换品牌"
        }),
        _createVNode(_component_el_table_column, {
          prop: "cat_name",
          label: "类型"
        }),
        _createVNode(_component_el_table_column, {
          prop: "feedback_time",
          label: "期望反馈时间",
          width: "98"
        }),
        _createVNode(_component_el_table_column, {
          prop: "raise_name",
          label: "需求提出人"
        }),
        _createVNode(_component_el_table_column, {
          prop: "add_time",
          label: "创建时间"
        }),
        _createVNode(_component_el_table_column, {
          prop: "creation_status_name",
          label: "合作方式"
        }),
        _createVNode(_component_el_table_column, {
          prop: "check_status_name",
          label: "状态"
        }),
        _createVNode(_component_el_table_column, {
          prop: "handler",
          label: "处理人"
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          fixed: "right",
          width: "141"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                onClick: ($event: any) => (toEdit(scope.row, 'view'))
              }, {
                default: _withCtx(() => _cache[9] || (_cache[9] = [
                  _createTextVNode("查看")
                ])),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_button, {
                disabled: scope.row.work_origin === _unref(ProjectOrigin)['内部创建'] || scope.row.check_status == 3,
                type: "primary",
                size: "small",
                onClick: ($event: any) => (toEdit(scope.row, 'edit'))
              }, {
                default: _withCtx(() => _cache[10] || (_cache[10] = [
                  _createTextVNode("去处理")
                ])),
                _: 2
              }, 1032, ["disabled", "onClick"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(Pagination, {
      total: total.value,
      currentPage: filters.page,
      onPageChange: onPageChange,
      onSizeChange: onSizeChange
    }, null, 8, ["total", "currentPage"])
  ]))
}
}

})